import { Button } from "~/ui-library";

export type LoadMoreButtonProps = {
  onClick?: () => void;
  updating?: boolean;
};

export const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  onClick,
  updating,
}) => (
  <div className="flex justify-center pt-s">
    <Button
      className="w-fit"
      data-testid="load-more-button"
      onClick={onClick}
      updating={updating}
      variant="default"
    >
      Load more
    </Button>
  </div>
);
